<template>

    <!-- app-layer {admin} -->
    <div class="app-layer admin" @click="layerClick($event)">

      <transition name="right-modal" v-show="show">

        <div class="modal-custom right" name="sync-info-admin" v-if="show" :class="{loading: loading}">

          <span class="close" @click="closeModal()">chiudi</span>

          <div class="content">
            <h1>Richiesta aggiornamento</h1>
            <p class="subdesc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt voluptatum fuga optio ullam non laudantium sequi sit a nostrum eos culpa officiis nemo dolorem laborum eveniet earum eum, illo officia?</p>

            <h3>Descrizione/Motivazione</h3>
            <textarea maxlength="500" v-model="description_sync" placeholder=" Facoltativo ..." name="description_sync" id="description_sync" cols="30" rows="10"></textarea>
            <span id="textarea-max-chars"> {{description_sync.length}}/ 500</span>
            <v-checkbox2 label="Non attendere l'esito dell'aggiornamneto: continuare la navigazione dopo l'avvio" v-model="type_sync_job" :trueValue="'dispatch'" :falseValue="'dispatchSync'"/>

            <button @click="startSync()" class="belt-btn animated mb-1" :class="{loading: loading}">AVVIA AGGIORNAMENTO</button>
          </div>


        </div>

      </transition>

  </div>

</template>

<script>
export default{

  props: {
    sync_info_admin: {type: Object},
  },

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data

      description_sync: '',
      type_sync_job: 'dispatch',

    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.manage_sync_new = false;

  },

  methods: {

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 200, this);

    },

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    startSync: function() {
      var vue = this;
      vue.loading = true;

      let settings = {
        description: ['', null].indexOf(vue.description_sync.trim()) < 0 ? vue.description_sync.trim() : null ,
        type_sync_job: vue.type_sync_job,
      };

      axios({
        method: "post",
        url: window.location.origin + '/data/updating-sync/start',
        params: {
          json: JSON.stringify(settings),
        },

      })
      .then(res => {
        if( res.data.sync.updatings ) vue.$parent.updatings = res.data.sync.updatings;
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        // ripristino opzioni iniziali
        vue.description_sync = '';
        vue.type_sync_job = 'dispatch';
        if (res.data.request.type_sync_job == 'dispatch') {
          vue.$parent.loadUpdatingSync();
        }
        vue.closeModal();
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile avviare l\'aggiornamento'
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },


  },


}
</script>

<style scoped>
.modal-custom{
  background-color: white;
  max-width: 800px;
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
}
#description_sync {
  width: 100%;
  padding: 1em;
  height: 150px;
}
#textarea-max-chars {
  font-size: 0.8em;
  color: var(--checkbox-gray);
}
p.subdesc, span.subdesc {
	margin-top: 0;
	color: var(--checkbox-gray);
}
</style>
